export default "__VITE_ASSET__085a7b3c__"